import { render, staticRenderFns } from "./zixunNei.vue?vue&type=template&id=acf6ded4&scoped=true"
import script from "./zixunNei.vue?vue&type=script&lang=js"
export * from "./zixunNei.vue?vue&type=script&lang=js"
import style0 from "./zixunNei.vue?vue&type=style&index=0&id=acf6ded4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf6ded4",
  null
  
)

export default component.exports